import type { DialogContentProps } from '@mui/material/DialogContent';

import Base from '@mui/material/DialogContent';
import * as React from 'react';

import { useScrollbarStyles } from '@egr/xbox/scroll-handling/Scrollbar';

export const DialogContent: React.ForwardRefExoticComponent<Omit<DialogContentProps, 'ref'> & React.RefAttributes<unknown>> = React.forwardRef((props, ref) => {
    const { classes } = useScrollbarStyles({});
    return (
        <Base className={classes.root} sx={{padding: '12px 0'}} {...props} ref={ref}>
            {props.children}
        </Base>
    );
});